import * as types from '../constants/drugstores';
import localStorage from 'store';

let initialState = {
  isLoading: false,
  drugstores: [],
  location: localStorage.get('drugstores_location') || {
    name: 'Киев',
    latitude: 50.4501,
    longitude: 30.5234,
  },
  mapCenter: localStorage.get('drugstores_location') || {
    latitude: 50.4501,
    longitude: 30.5234,
  },
  radius: 25000,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case types.SET_LOADER:
      return {
        ...state,
        isLoading: payload,
      };
    case types.SET_DRUGSTORES:
      return {
        ...state,
        drugstores: payload,
      };
    case types.SET_LOCATION:
      return {
        ...state,
        location: payload,
      };
    case types.SET_MAP_CENTER:
      return {
        ...state,
        mapCenter: payload,
      };
    case types.SET_RADIUS:
      return {
        ...state,
        radius: payload,
      };
    default:
      return state;
  }
};
